<!-- 忘记密码第二部 -->
<template>
  <div id="forget-pwd">
    <div class="forget-pwd"
         @keydown.enter="resetHandle">
      <div class="logo">
        <img :src="logo"
             alt="">
      </div>
      <p>MSP - Reset password</p>
      <Form ref="formValidate"
            :model="formValidate"
            :rules="ruleValidate">
        <FormItem label=""
                  prop="newPwd">
          <Input v-model="formValidate.newPwd"
                 placeholder="New password"
                 type="password"></Input>
        </FormItem>
        <FormItem label=""
                  prop="surePwd">
          <Input v-model="formValidate.surePwd"
                 placeholder="New password again"
                 type="password"></Input>
        </FormItem>
      </Form>
      <div class="forget-pwd-btn"
           style="margin-top:86px;">
        <Button class="zlr-btn-primary"
                @click="resetHandle"
                :loading="isSub">Reset</Button>
      </div>
    </div>
    <Bottom></Bottom>
    <canvas id="canvas"></canvas>
  </div>
</template>

<script>
// api
import { passReset } from '@/api/talents'
// less
import './index.less'
// mixins
import bgColor from '@/view/mixins/bg-color-blue'
// images
import logo from '@/assets/Logo.svg'
import Bottom from './intro-bottom'
import wave from './wave.js'
export default {
  name: 'forget-pwd1',
  mixins: [bgColor],
  components: {
    Bottom
  },
  data () {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter your password'))
      } else if (value !== this.formValidate.newPwd) {
        callback(new Error('The entered passwords are inconsistent'))
      } else {
        callback()
      }
    }
    return {
      logo,
      formValidate: {},
      ruleValidate: {
        newPwd: [{ required: true, message: 'Please enter your new password' }],
        surePwd: [{ required: true, message: 'Please enter your password' }, { validator: validatePass }]
      },
      isSub: false
    }
  },
  computed: {},
  mounted () {
    wave()
    let params = this.$route.params
    if (!params.code && !params.email) {
      this.$router.push({
        name: 'forget'
      })
    } else {
      Object.assign(this.formValidate, {
        email: params.email,
        code: params.code
      })
    }
  },
  methods: {
    resetHandle () {
      if (this.isSub) return false
      this.$refs['formValidate'].validate((valid) => {
        if (valid) {
          let data = Object.assign({}, this.formValidate)
          this.isSub = true
          passReset(data).then(res => {
            this.$zlr_message('Your password has been reset successfully!', 'success')
            let timeout = setTimeout(() => {
              this.$router.push({
                name: 'login'
              })
              clearTimeout(timeout)
            }, 2500)
          }).catch(error => {
            this.$zlr_message(error.message, 'error')
          }).then(() => {
            this.isSub = false
          })
        }
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
